// Author facts shown in the byline and the Article structured data. The
// decision that scopes bylines to Learn articles is
// docs/seo/decisions/2026-11-01-learn-article-authorship-and-dates.md.
export interface LearnAuthor {
  id: string;
  name: string;
  title: string;
  nmls: string;
  /** The author's page in the public loan-officer directory. */
  profilePath: string;
}

export const LEARN_AUTHORS = {
  'anthony-amini': {
    id: 'anthony-amini',
    name: 'Anthony Amini',
    title: 'President and CEO',
    nmls: '1225724',
    profilePath: '/loan-officers/anthony-amini',
  },
} as const satisfies Record<string, LearnAuthor>;

export type LearnAuthorId = keyof typeof LEARN_AUTHORS;
